export function parseLocalDate(value: string) {
  const [year, month, day] = value.split('-').map((part) => Number(part));
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return new Date(NaN);
  }
  return new Date(year, month - 1, day);
}

export function parseISOToLocalDate(value: string | Date) {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  if (typeof value !== 'string' || !value) return new Date(NaN);
  if (!value.includes('T')) {
    return parseLocalDate(value);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return new Date(NaN);
  }
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function formatDateOnly(value: string | Date) {
  const date = parseISOToLocalDate(value);
  if (Number.isNaN(date.getTime())) {
    if (typeof value === 'string') return value;
    if (value instanceof Date) return value.toLocaleDateString('en-US');
    return '';
  }
  return date.toLocaleDateString('en-US');
}

export function formatDateKey(value: Date) {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatTimeZoneLabel(timeZone: string, reference: Date = new Date()) {
  if (!timeZone) return '';
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    }).formatToParts(reference);
    return parts.find((part) => part.type === 'timeZoneName')?.value ?? timeZone;
  } catch {
    return timeZone;
  }
}

export function formatTimeWithZone(time: string, timeZoneLabel?: string) {
  if (!timeZoneLabel) return time;
  return `${time} ${timeZoneLabel}`;
}
